module.exports = __webpack_public_path__ + "img/pagebanner-teams.d53b76c8.jpg";